import { request } from './client';
import type { UserProfileResponse } from './types';

export function getMyProfile() {
  return request<UserProfileResponse>('/api/users/me/profile', {
    method: 'GET',
  });
}

export function updateMailNotification(mailNotificationEnabled: boolean) {
  return request<UserProfileResponse>('/api/users/me/mail-notification', {
    method: 'PATCH',
    body: { mailNotificationEnabled },
  });
}
